import Immutable from 'immutable';

import { ActionTypes } from './actions';

export const initialState = Immutable.fromJS({});

const setMaintenanceDashboardData = (state, { maintenanceDashboardData }) => {
  if (!maintenanceDashboardData) return state;
  return state.merge({ maintenanceDashboardData });
};

const setMaintenanceJobs = (state, { maintenanceJobsData }) => {
  if (!maintenanceJobsData) return state;
  return state.merge({ maintenanceJobsData });
};

const setFactoryLabours = (state, { factoryLaboursData }) => {
  if (!factoryLaboursData) return state;
  return state.merge({ factoryLaboursData });
};

const setFactoryDepartments = (state, { factoryDepartmentsData }) => {
  if (!factoryDepartmentsData) return state;
  return state.merge({ factoryDepartmentsData });
};

const setPartListByPartType = (state, { partListData }) => {
  if (!partListData) return state;
  return state.merge({ partListData });
};

const setMaintenanceImagesByJob = (state, { maintenanceImagesListData }) => {
  if (!maintenanceImagesListData) return state;
  return state.merge({ maintenanceImagesListData });
};

const setLoader = (state, { showLoader }) => {
  return state.merge({ showLoader });
};

const setMaintenanceImagesByJobLoaderStatus = (state, { maintenanceImageLoader }) => {
  return state.merge({ maintenanceImageLoader });
};

const setUploadMaintenanceImageLoaderStatus = (state, { maintenanceUploadImageLoader }) => {
  return state.merge({ maintenanceUploadImageLoader });
};

export const callbacks = [
  {
    actionType: ActionTypes.SET_MAINTENANCE_DASHBOARD_DATA,
    actionFunction: setMaintenanceDashboardData,
  },
  {
    actionType: ActionTypes.SET_MAINTENANCE_JOBS,
    actionFunction: setMaintenanceJobs,
  },
  {
    actionType: ActionTypes.SET_FACTORY_LABOURS,
    actionFunction: setFactoryLabours,
  },
  {
    actionType: ActionTypes.SET_FACTORY_DEPARTMENTS,
    actionFunction: setFactoryDepartments,
  },
  {
    actionType: ActionTypes.SET_PART_LIST_BY_PART_TYPE,
    actionFunction: setPartListByPartType,
  },
  {
    actionType: ActionTypes.SET_MAINTENANCE_IMAGES_BY_JOB,
    actionFunction: setMaintenanceImagesByJob,
  },
  {
    actionType: ActionTypes.SET_LOADER_STATUS,
    actionFunction: setLoader,
  },
  {
    actionType: ActionTypes.SET_MAINTENANCE_IMAGES_BY_JOB_LOADER_STATUS,
    actionFunction: setMaintenanceImagesByJobLoaderStatus,
  },
  {
    actionType: ActionTypes.SET_UPLOAD_MAINTENANCE_IMAGE_LOADER_STATUS,
    actionFunction: setUploadMaintenanceImageLoaderStatus,
  },
];
